import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';

import Divider from '@mui/material/Divider';
import MessageIcon from '@mui/icons-material/Message';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import LeadComment from './LeadComment';
import LeadCommentSubscribers from './LeadCommentSubscribers';
import CommentEditor from './CommentEditor';

const LeadComments = props => {
  const {lead} = props;
  return (
    <Stack gap={1}>
      <Stack direction='row' spacing={1} alignItems='center'>
        <MessageIcon style={{fontSize: '1.1rem'}} />
        <Typography variant='h3'>Comments</Typography>
      </Stack>
      <Divider/>
      {
        lead?.comments?.length === 0 &&
        <Typography align='center' variant='body1'>No comments yet</Typography>
      }
      {sortBy((lead?.comments || []), l => l.id)
        .map(c => (
          <LeadComment key={c.id} comment={c} />
        ))
        }
      <CommentEditor lead={lead} />
      <Typography variant='h4'>Subscribers</Typography>
      <LeadCommentSubscribers lead={lead} />
    </Stack>
  );
};

LeadComments.propTypes = {
  lead: PropTypes.object.isRequired,
};

export default LeadComments;